import { render, staticRenderFns } from "./createConfig.vue?vue&type=template&id=6bb8d41c&scoped=true&"
import script from "./createConfig.vue?vue&type=script&lang=js&"
export * from "./createConfig.vue?vue&type=script&lang=js&"
import style0 from "./createConfig.vue?vue&type=style&index=0&id=6bb8d41c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb8d41c",
  null
  
)

export default component.exports